module.exports = __webpack_public_path__ + "img/合同签订.1e725801.svg";